module.exports = __webpack_public_path__ + "static/media/3f.832b977c.jpg";